customElements.get("range-slider") || customElements.define("range-slider", class extends HTMLElement {
  constructor() {
    super(), this.rangeMin = this.querySelector("[data-range-min]"), this.rangeMax = this.querySelector("[data-range-max]"), 
    this.inputMin = this.querySelector("[data-input-min]"), this.inputMax = this.querySelector("[data-input-max]"), 
    this.dotMin = this.querySelector("[data-dot-min]"), this.dotMax = this.querySelector("[data-dot-max]"), 
    this.dragging = null;
  }
  connectedCallback() {
    this.addEventListeners(), this.checkQueryParams();
  }
  checkQueryParams() {}
  addEventListeners() {
    this.inputMin.addEventListener("focus", () => this.inputMin.select()), this.inputMax.addEventListener("focus", () => this.inputMax.select()), 
    this.inputMin.addEventListener("change", t => {
      t.preventDefault(), t.target.value = Math.max(Math.min(parseInt(t.target.value), parseInt(this.inputMax.value || t.target.max) - 1), t.target.min), 
      this.rangeMin.value = t.target.value, this.style.setProperty("--min", parseInt(this.rangeMin.value) / parseInt(this.rangeMin.max) * 100 + "%"), 
      this.checkQueryParams();
    }), this.inputMax.addEventListener("change", t => {
      t.preventDefault(), t.target.value = Math.min(Math.max(parseInt(t.target.value), parseInt(this.inputMin.value || t.target.min) + 1), t.target.max), 
      this.rangeMax.value = t.target.value, this.style.setProperty("--max", 100 - parseInt(this.rangeMax.value) / parseInt(this.rangeMax.max) * 100 + "%"), 
      this.checkQueryParams();
    }), this.rangeMin.addEventListener("change", t => {
      t.stopPropagation(), this.inputMin.value = t.target.value, this.inputMin.dispatchEvent(new Event("change", {
        bubbles: !0
      }));
    }), this.rangeMax.addEventListener("change", t => {
      t.stopPropagation(), this.inputMax.value = t.target.value, this.inputMax.dispatchEvent(new Event("change", {
        bubbles: !0
      }));
    }), this.rangeMin.addEventListener("input", t => {
      t.target.value = Math.min(parseInt(t.target.value), parseInt(this.inputMax.value || t.target.max) - 1), 
      this.style.setProperty("--min", parseInt(t.target.value) / parseInt(t.target.max) * 100 + "%"), 
      this.inputMin.value = t.target.value;
    }), this.rangeMax.addEventListener("input", t => {
      t.target.value = Math.max(parseInt(t.target.value), parseInt(this.inputMin.value || t.target.min) + 1), 
      this.style.setProperty("--max", 100 - parseInt(t.target.value) / parseInt(t.target.max) * 100 + "%"), 
      this.inputMax.value = t.target.value;
    }), this.dotMin.addEventListener("mousedown", t => this.onDragStart(t, "min")), 
    this.dotMax.addEventListener("mousedown", t => this.onDragStart(t, "max")), this.dotMin.addEventListener("touchstart", t => this.onDragStart(t, "min")), 
    this.dotMax.addEventListener("touchstart", t => this.onDragStart(t, "max"));
  }
  onDragStart(t, e) {
    "touchstart" === t.type && t.preventDefault(), this.dragging = e, document.addEventListener("mousemove", this.onDrag), 
    document.addEventListener("mouseup", this.onDragEnd), document.addEventListener("touchmove", this.onDrag, {
      passive: !1
    }), document.addEventListener("touchend", this.onDragEnd);
  }
  onDrag=t => {
    if (!this.dragging) return;
    "touchmove" === t.type && t.preventDefault();
    const e = t.type.startsWith("touch") ? t.touches[0].clientX : t.clientX, a = this.getBoundingClientRect();
    let n = (e - a.left) / a.width;
    n = Math.max(0, Math.min(1, n));
    const i = this.rangeMin.max - this.rangeMin.min;
    let s = this.rangeMin.min + n * i;
    "min" === this.dragging ? (s = Math.min(s, this.inputMax.value - 1), this.rangeMin.value = s, 
    this.rangeMin.dispatchEvent(new Event("input", {
      bubbles: !0
    })), this.rangeMin.dispatchEvent(new Event("change", {
      bubbles: !0
    }))) : (s = Math.max(s, this.inputMin.value + 1), this.rangeMax.value = s, this.rangeMax.dispatchEvent(new Event("input", {
      bubbles: !0
    })), this.rangeMax.dispatchEvent(new Event("change", {
      bubbles: !0
    })));
  };
  onDragEnd=() => {
    this.dragging = null, document.removeEventListener("mousemove", this.onDrag), document.removeEventListener("mouseup", this.onDragEnd), 
    document.removeEventListener("touchmove", this.onDrag), document.removeEventListener("touchend", this.onDragEnd);
  };
});